import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../../shared/toast/toast';
import {IdexService} from '../../../idex.service';
import {DateAdapter} from '@angular/material/core';
import {ActivatedRoute} from '@angular/router';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import { FileSizePipe } from 'app/shared/file-size.pipe';
declare var $: any;

@Component({
  selector: 'app-insert-merge-files',
  templateUrl: './insert-merge-files.component.html',
  styleUrls: ['./insert-merge-files.component.css']
})
export class InsertMergeFilesComponent implements OnInit {
   @Input() LIMIT_UPLOAD_SIZE_BYTE: number;

   public doclist = {
      docId: '',
      docName: '',
      totalPages: '',
      signItems: []
   };

   public docNew: string[] = [];
   public files = [];
   public taskName;
   public taskId = 0;
   public template;
   public dueDate;
   public priority;
   public documents: any;
   public isDocList = false;
   private path: string;
   private subscriber: Subscription;
   protected fileSize: FileSizePipe;

   fileName = '';
   error: string;
   errorMessage: any;
   mimetype = [];
   object_file: any;
   items: any[];
   info: any;
   watermark: any;
   file: FileList;
   item: any;
   limit: any;
   selectedItems: any[] = [];
   page: any;
   checkAnno: any;
   annotationId: any;
   annotationVersion: any;

   constructor(private translate: TranslateService,
               public toast: Toast,
               public service: IdexService,
               private dateAdapter: DateAdapter<any>,
               private route: ActivatedRoute,
               private dialogRef: MatDialogRef<InsertMergeFilesComponent>,
               private _fileSize: FileSizePipe
               ) {
                  this.fileSize = _fileSize;
               }

   ngOnInit() {
      this.docNew = [];
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this.dateAdapter.setLocale('th');
         } else {
            this.dateAdapter.setLocale('en');
         }
      });
      this.subscriber = this.route.url.subscribe(url => {
         this.path = decodeURIComponent(url.join('/'));
      });
      this.getWatermark();
   }

   getWatermark() {
      this.service.getWatermark('PDFTron').subscribe((data) => {
         this.watermark = data;
      });
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         $('#divUpload').addClass('drag-over');
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      $('#divUpload').removeClass('drag-over');
      const data = event.dataTransfer;
      let files;
      if (data.items) {
         files = [];
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               files.push(data.items[i].getAsFile());
            }
         }
      } else {
         files = data.files;
      }
      if (files.length > 1) {
         this.handleToastError('uploadDoc.errorSelectFile');
      } else {
         this.file = data.files;
         this.fileName = files[0].name;
      }
   }

   onDragLeave() {
      $('#divUpload').removeClass('drag-over');
   }

   onSelectFiles(input: any) {
      if (input.files.length === 0) {
         return;
      }
      const files = input.files;
      this.file = files;
      this.fileName = files[0].name;
   }

   protected checkFileSizeUnderLimit() {
      if(!this.file) return;
      if(this.file[0].size > this.LIMIT_UPLOAD_SIZE_BYTE) {
         return false;
      }
      return true;
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   onSubmit() {
      if (this.fileName !== '' && this.checkFileSizeUnderLimit()) {
         this.dialogRef.close(this.file);
      } else {
         this.translate.get('please-select-file').subscribe( s => {
            this.toast.warn(s);
         });
      }
   }

}
